import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { Bloguser } from './bloguser.page';
export const routes: Routes = [
    { path: 'bloguser', component: Bloguser }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        Bloguser
    ]
})
export class BloguserModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/bloguser/bloguser.module.ts